import { Asset } from "./Asset";
import { Engine } from "@spi/Engine/Engine";

export class HttpBinaryAsset extends Asset {

    constructor(private uri: string, private callback: (engine: Engine, buffer: ArrayBuffer) => void) {
        super();
    }

    async resolveAsset(engine: Engine): Promise<void> {
        this.callback(engine, await engine.ctx.resourceLoader.loadResource(this.uri));
    }

}
